import { useState } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import {
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Box,
  Typography
} from '@mui/material';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import NavItem from './NavItem';
import { useGetMenuMaster } from 'api/menu';
import { getNavIconBoxSx, NAV } from '../../drawerNavStyles';

export default function NavCollapse({ item, level = 1 }) {
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster?.isDashboardDrawerOpened;
  const { pathname } = useLocation();

  const isChildActive = item.children?.some((child) =>
    matchPath({ path: child?.link || child.url, end: false }, pathname)
  );
  const [open, setOpen] = useState(isChildActive || false);

  const Icon = item.icon;
  const isActive = isChildActive;

  if (!drawerOpen) {
    return (
      <Box sx={{ py: 0.5, display: 'flex', justifyContent: 'center' }}>
        {Icon && (
          <Box
            sx={{
              ...getNavIconBoxSx(isActive),
              cursor: 'pointer',
              '&:hover': { bgcolor: isActive ? NAV.iconBgActive : NAV.hover }
            }}
            onClick={() => setOpen(!open)}
          >
            <Icon style={{ fontSize: '1.125rem' }} />
          </Box>
        )}
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 0.25 }}>
      <ListItemButton
        onClick={() => setOpen(!open)}
        sx={{
          borderRadius: NAV.radius,
          mx: NAV.mx,
          mb: 0.5,
          py: 0.75,
          px: 1,
          minHeight: NAV.itemHeight,
          transition: 'all 0.2s ease',
          bgcolor: isActive ? NAV.activeSoft : 'transparent',
          '&:hover': { bgcolor: isActive ? 'rgba(31, 91, 64, 0.14)' : NAV.hover }
        }}
      >
        {Icon && (
          <ListItemIcon sx={{ minWidth: NAV.iconSize + 8, mr: 1.25 }}>
            <Box sx={getNavIconBoxSx(false)}>
              <Icon style={{ fontSize: '1.125rem' }} />
            </Box>
          </ListItemIcon>
        )}
        <ListItemText
          primary={
            <Typography
              variant="body2"
              sx={{
                fontWeight: isActive ? 600 : 500,
                color: isActive ? 'primary.main' : 'text.primary',
                fontSize: '0.875rem',
                letterSpacing: '-0.01em'
              }}
            >
              {item.title}
            </Typography>
          }
        />
        <Box
          sx={{
            width: 28,
            height: 28,
            borderRadius: 1.5,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: open ? 'rgba(31, 91, 64, 0.1)' : 'rgba(31, 91, 64, 0.05)',
            transition: 'all 0.2s ease'
          }}
        >
          <KeyboardArrowDownRoundedIcon
            sx={{
              fontSize: '1.125rem',
              color: isActive ? 'primary.main' : 'text.secondary',
              transition: 'transform 0.25s ease',
              transform: open ? 'rotate(180deg)' : 'rotate(0deg)'
            }}
          />
        </Box>
      </ListItemButton>

      <Collapse in={open} timeout={280} unmountOnExit>
        <Box
          sx={{
            ml: 2.5,
            mr: NAV.mx,
            pl: 1.5,
            borderLeft: `2px solid ${NAV.submenuBorder}`,
            mb: 0.5
          }}
        >
          <List disablePadding>
            {item.children?.map((child) => (
              <NavItem key={child.id} item={child} level={level + 1} />
            ))}
          </List>
        </Box>
      </Collapse>
    </Box>
  );
}
